export default __webpack_public_path__ + "static/media/September_04.bcd4bb01.png";